import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { cn } from "@/lib/cn";

import { Header } from "@/components/Header";
import { Icon } from "@/components/ui/Icon";

import { AdminBottomNav } from "./AdminBottomNav";

export const AdminLayout = () => (
  <div
    className={cn(
      // Layout: на mobile — естественный скролл страницы; на desktop — fixed height без скролла страницы
      "flex min-h-screen w-full flex-col md:h-screen md:overflow-hidden",
      // Background
      "bg-background"
    )}
  >
    {/* Fixed header */}
    <Header variant="profile" />

    {/* Page content — на mobile без min-h-0 (естественная высота), на desktop — internal scroll */}
    <main className="flex flex-1 px-3 py-4 pb-24 md:min-h-0 md:px-6 md:py-5 md:pb-20">
      <Suspense
        fallback={
          <div className="flex flex-1 items-center justify-center">
            <Icon
              name="spinner"
              className="size-6 animate-spin text-neutral-500"
            />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </main>

    {/* Bottom Navigation */}
    <AdminBottomNav />
  </div>
);
